



































import Component from 'vue-class-component';
import BaseComponent from '../../../core/base.component';
import {
  FounderConsultManagementDto,
  FounderConsultManagementListDto,
} from '../../../dto';
import FounderConsultManagementService from '../../../services/founder-consult-management.service';
import { Pagination } from '../../../common';
@Component({
  name: 'FounderConsultManagementHistory',
})
export default class FounderConsultManagementHistory extends BaseComponent {
  private founderConsultManagementHistoryList: FounderConsultManagementDto[] = [];
  private founderConsultManagementHistoryListDto = new FounderConsultManagementListDto();
  private founderConsultManagementHistoryListCount = 0;
  private pagination = new Pagination();

  findHistory(isPagination?: boolean) {
    if (!isPagination) {
      this.pagination.page = 1;
    }
    this.pagination.limit = 5;
    const fondConsultNo = this.$route.params.id;
    FounderConsultManagementService.findAll(
      fondConsultNo,
      this.founderConsultManagementHistoryListDto,
      this.pagination,
    ).subscribe(res => {
      this.founderConsultManagementHistoryList = res.data.items;
      this.founderConsultManagementHistoryListCount = res.data.totalCount;
    });
  }

  paginateSearch() {
    this.findHistory(true);
  }

  created() {
    this.findHistory();
  }
}
